<template>
    <div class="layer-content common" style="padding:20px;max-height: 800px">
        <div class="tit-type2">1. 복지부 보조금 지원에 해당되는 수량 : 왼쪽 정산구분 항목 보조금에서 수량 입력</div>
        <div class="box-type01 pd10">
	        <ul class="depth1">
	        	<li class="txt-type4">추후, 보조금 정산과정에서 입력하신대로 보조금관련 세금계산서 등을 따로 발급.</li>
	        	<li class="txt-type4">참고사항 : 지자체에 문의 후 보조금으로 지원되는 리더기와 태그수량 기준을 확인요망.</li>
	        	<li class="txt-type4">태그 수량은 전년도 12월 말일 현원 기준으로 원아당 5,000원 씩 지급 </li>
	        </ul>
        </div>
<!--        <div class="tit-type2 mgt20">2. 보조금외 어린이집 자부담 수량 : 오른쪽 정산구분 항목 자부담금에서 수량 입력</div>-->
        <div class="tit-type2 mgt20">2. 결제방법 카드결제  : 결제카드정보를 입력 </div>
        <div class="box-type01 pd10">
	        <ul class="depth1">
	        	<li class="txt-type4">지금 바로 결제되지 않음</li>
	        </ul>
        </div>
        <div class="tit-type2 mgt20">3. 결제방법 무통장결제 : 추후 결제일 통보 </div>
        <div class="box-type01 pd10">
	        <ul class="depth1">
	        	<li class="txt-type4">바로 신청완료 가능 </li>
	        </ul>
        </div>
    </div>
</template>

<script>
export default {
    name : 'orderSeInfoPopup'
}
</script>
